import classNames from "classnames";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { ThemeContext } from "../../contexts/ThemeContext";

export const TEST_ID_FIELD_ERRORS = "field-errors";

type FieldErrorProps = {
  touched?: boolean;
  value?: string;
};

const FieldErrors: React.FC<FieldErrorProps> = ({ touched, value }) => {
  const { styles } = useContext(ThemeContext);
  return touched && value ? (
    <p
      className={classNames(styles.paragraph3, "red mv0")}
      data-testid={TEST_ID_FIELD_ERRORS}
    >
      <FormattedMessage id={value} />
    </p>
  ) : null;
};

export default FieldErrors;
